import React from "react";
import ReactModal from "react-modal";
import { BiLogOut } from "react-icons/bi";
import { IoIosCloseCircleOutline } from "react-icons/io";

function PreviewModel({ selectedFile, isOpen, onClose }) {
  // const handleAvatarClick = () => {
  //   fileInputRef.current.click();
  // };

  return (
    <ReactModal
      isOpen={isOpen}
      onRequestClose={onClose}
      className="bg-transparent rounded-lg p-6 max-w-lg mx-auto my-20 relative max-h-lg  sm:w-[30%] md:w-[55%] lg:w-[45%] outline-none"
      overlayClassName="fixed inset-0 bg-black bg-opacity-50 flex items-center justify-center z-10"
    >
      <div className="w-full flex items-center justify-center flex-col">
        <div className="w-[550px] flex items-end justify-end pb-5 cursor-pointer">
          <IoIosCloseCircleOutline color="white" size={24} onClick={onClose} />
        </div>
        <div>
          <img
            src={selectedFile?.preview}
            alt="Avatar"
            className="w-[500px] h-96  object-cover cursor-pointer"
          />

        </div>
      </div>
    </ReactModal>
  );
}

export default PreviewModel;
